module.exports = __webpack_public_path__ + "img/37-02.50b96b2c.png";